import React, { useId, useState } from 'react'
import { Notice } from '../../../../shared/sso-workspace/fleet-page'
import { serverMessage } from '../../../../shared/error/server-message'
import { ErrorReference } from '../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../shared/error/use-error-line'
import { verifySignature } from './consent-log-api'

// Whether a visitor's consent ID and signature (both in their consent ID
// cookie) belong together, i.e. we issued that ID.
export const VerifyTab = () => {
  const ids = { id: useId(), signature: useId() }
  const [consentId, setConsentId] = useState('')
  const [signature, setSignature] = useState('')
  const [result, setResult] = useState(null)
  const [busy, setBusy] = useState(false)
  const [error, failure, setError] = useErrorLine()

  const verify = async e => {
    e.preventDefault()
    const id = consentId.trim()
    const sig = signature.trim()
    if (!id || !sig || busy) return
    setBusy(true)
    setError(null)
    setResult(null)
    try {
      const body = await verifySignature(id, sig)
      setResult(!!(body && body.valid))
    } catch (err) {
      setError(serverMessage(err, "The signature couldn't be checked."), err)
    }
    setBusy(false)
  }

  return (
    <>
      <form className="ak-filters" onSubmit={verify}>
        <div className="ak-filter">
          <label className="sw-label" htmlFor={ids.id}>Consent ID</label>
          <input id={ids.id} type="text" className="form-control sw-mono" autoComplete="off" spellCheck={false} value={consentId} onChange={e => { setConsentId(e.target.value); setResult(null) }} />
        </div>
        <div className="ak-filter">
          <label className="sw-label" htmlFor={ids.signature}>Signature</label>
          <input id={ids.signature} type="text" className="form-control sw-mono" autoComplete="off" spellCheck={false} value={signature} onChange={e => { setSignature(e.target.value); setResult(null) }} />
        </div>
        <div className="ak-filter">
          <button type="submit" className="btn sw-btn-primary" disabled={!consentId.trim() || !signature.trim() || busy}>Verify</button>
        </div>
      </form>

      {error && <Notice tone="bad" role="alert">{error}<ErrorReference error={failure} /></Notice>}
      {result === true && <Notice tone="ok" role="status">Valid. We issued this consent ID.</Notice>}
      {result === false && <Notice tone="warn" role="status">Not valid. This signature doesn't belong to this consent ID.</Notice>}
    </>
  )
}
